import i18n from '@/lib/i18n/i18n';
import formatCurrency from '@/lib/utils/formatCurrency';

import type { RiskObjectGroups, ROCarMinimal } from '../types';

const GROUPS: RiskObjectGroups<ROCarMinimal> = [
  {
    title: 'RO_SECTION_OVERVIEW',
    properties: [
      {
        label: 'RO_CAR_BRAND',
        getValue: (car) => car.brand,
      },
      {
        label: 'RO_CAR_MODEL',
        getValue: (car) => car.model,
      },
      {
        label: 'RO_CAR_VERSION',
        getValue: (car) => car.version,
      },
      {
        label: 'RO_CAR_MODEL_YEAR',
        getValue: (car) => car.model_year,
      },
      {
        label: 'RO_CAR_VEHICLE_TYPE',
        getValue: (car) =>
          car.vehicle_type && i18n.t(`VEHICLE_TYPE_${car.vehicle_type}`),
      },
      // {
      //   label: 'RO_CAR_CATEGORY',
      //   getValue: (car) => car.category && i18n.t(`CATEGORY_${car.category}`),
      // },
      // {
      //   label: 'RO_CAR_SEATS',
      //   getValue: (car) => car.seats,
      // },
      // {
      //   label: 'RO_CAR_COLOR',
      //   getValue: (car) => car.color,
      // },
    ],
  },
  {
    title: 'RO_SECTION_REGISTRATION',
    properties: [
      {
        label: 'RO_CAR_NUMBER_PLATE',
        getValue: (car) => car.number_plate,
      },
      {
        label: 'RO_CAR_CHASSIS_NUMBER',
        getValue: (car) => car.chassis_number,
      },
      // {
      //   label: 'RO_CAR_LICENSE_PLATE_TYPE',
      //   getValue: (car) => car.license_plate_type,
      // },
      // {
      //   label: 'RO_CAR_COUNTRY_OF_REGISTRATION',
      //   getValue: (car) => car.country_of_registration,
      // },
      // {
      //   label: 'RO_CAR_FIRST_REGISTRATION',
      //   getValue: (car) => car.registration_first,
      // },
      // {
      //   label: 'RO_CAR_LAST_REGISTRATION',
      //   getValue: (car) => car.registration_last,
      // },
      // {
      //   label: 'RO_CAR_PURCHASE_DATE',
      //   getValue: (car) => car.purchase_date,
      // },
      // {
      //   label: 'RO_CAR_MELDCODE',
      //   getValue: (car) => car.meldcode,
      // },
    ],
  },
  {
    title: 'RO_SECTION_ENGINE',
    properties: [
      {
        label: 'RO_CAR_FUEL_TYPE',
        getValue: (car) =>
          car.motor_type && i18n.t(`FUEL_TYPE_${car.motor_type}`),
      },
      // {
      //   label: 'RO_CAR_TRANSMISSION',
      //   getValue: (car) =>
      //     car.transmission_type &&
      //     i18n.t(`TRANSMISSION_${car.transmission_type}`),
      // },
      // {
      //   label: 'RO_CAR_DISPLACEMENT',
      //   getValue: (car) => car.cc && `${car.cc}cc`,
      // },
      {
        label: 'RO_CAR_POWER_KW',
        getValue: (car) => car.kw && `${car.kw}kW`,
      },
      // {
      //   label: 'RO_CAR_FUEL_TYPE',
      //   getValue: (car) => car.hp,
      //   type: 'DEFAULT',
      //   unit: 'pk',
      // },
      // {
      //   label: 'RO_CAR_BATTERY_CAPACITY',
      //   getValue: (car) => car.kwh && `${car.kwh}kWh`,
      // },
      // {
      //   label: 'RO_CAR_EMISSION',
      //   getValue: (car) => car.co2 && `${car.co2}g/km`,
      // },
      // {
      //   label: 'RO_CAR_WEIGHT',
      //   getValue: (car) => car.weight_in_kg && `${car.weight_in_kg}/kg`,
      // },
    ],
  },
  {
    title: 'RO_SECTION_PRICE',
    properties: [
      {
        label: 'RO_CAR_CATALOGUE_VALUE',
        getValue: (car) => formatCurrency(car.value),
      },
      // {
      //   label: 'RO_CAR_OPTIONS_VALUE',
      //   getValue: (car) => formatCurrency(car.options_value),
      // },
      // {
      //   label: 'RO_CAR_INVOICE_VALUE',
      //   getValue: (car) => formatCurrency(car.invoice_value),
      // },
      // {
      //   label: 'RO_CAR_VAT_RATE',
      //   getValue: (car) => `${car.vat_rate * 100}%`,
      // },
    ],
  },
  {
    title: 'RO_SECTION_USAGE',
    properties: [
      // {
      //   label: 'RO_CAR_USAGE',
      //   getValue: (car) => car.used_for,
      // },
      // {
      //   label: 'RO_CAR_KM_PER_YEAR',
      //   getValue: (car) => car.km_per_year,
      // },
      // {
      //   label: 'RO_CAR_MILEAGE',
      //   getValue: (car) =>
      //     car.mileage?.mileage_counter
      //       ? `${car.mileage.mileage_counter} ${car.mileage?.mileage_unit ?? 'km'}`
      //       : undefined,
      // },
      // {
      //   label: 'RO_CAR_CLAIM_FREE_YEARS',
      //   getValue: (car) => car.claim_free_years,
      // },
      // {
      //   label: 'RO_CAR_IS_SECOND_HAND',
      //   getValue: (car) => yesNo(car.is_second_hand),
      // },
      // {
      //   label: 'RO_CAR_IS_SPORTSCAR',
      //   getValue: (car) => yesNo(car.is_sportscar),
      // },
    ],
  },
];

export default GROUPS;
